<template>
    <div class="vtext">
        助花订单列表
    </div>
    <div class="order">
        <el-tabs v-model="activeName" class="demo-tabs" @tab-click="handleClick">
            <el-tab-pane :label="'交易订单（' + totallists + '件）'" name="first">
                <OrderLists @totallist="totallist"></OrderLists>
            </el-tab-pane>
            <el-tab-pane :label="'积分商品交易（' + totals + '件）'" name="second">
                <DanIntegral @totaldan="totaldan"></DanIntegral>
            </el-tab-pane>
            <el-tab-pane label="零元购订单" name="zero">
                <ZerobuyList @totallist="totallist"></ZerobuyList>
            </el-tab-pane>
             <el-tab-pane label="礼包领取" name="libao">
                <LibaoOrder></LibaoOrder>
            </el-tab-pane>
            <el-tab-pane label="待发货订单" name="dafa">
                <DaFa></DaFa>
            </el-tab-pane>
        </el-tabs>

    </div>
</template>

<script setup>
import { ref } from 'vue'
import OrderLists from '@/components/Orderlists.vue'
import DanIntegral from '@/components/DanIntegral.vue';
import DaFa from '@/components/DaFa.vue'
import LibaoOrder from '@/components/LibaoOrder.vue'
import ZerobuyList from '@/components/ZerobuyList.vue'
import { useRouter } from 'vue-router';
const router = useRouter()
const activeName = ref('first')
const handleClick = (tab, event) => {
    console.log(tab, event)
}
let totallists = ref(0)
const totallist = (value) => {
    totallists.value = value
}

let totals = ref(0)
const totaldan = (value) => {
    totals.value = value
}
</script>

<style lang="scss" scoped>
::v-deep .el-pagination {
    position: absolute;
    bottom: 15px;
    right: 34px;


    .number,
    .btn-quicknext,
    .is-last,
    .is-first {
        background-color: transparent !important;
    }

    .is-active {
        background-color: #EBF3FF !important;
        color: #1787FF !important;
        border-radius: 8px;
    }

}

::v-deep .demo-tabs {
    height: 100%;

    .el-tabs__header {
        margin-bottom: 0;
    }

    .el-tabs__content {
        height: calc(100% - 60px);
    }

    .el-tabs__nav-scroll {

        .el-tabs__nav {

            .el-tabs__item {
                height: 60px !important;
                margin-right: 61px;
            }
        }
    }

    #tab-first {
        margin-left: 24px !important;
    }
}

.vtext {
    height: 50px;
    font-size: 32px;
    font-weight: 400;
    color: #0A1629;
    line-height: 50px;
}

.order {
    position: relative;
    height: calc(100% - 82px);
    background-color: #fff;
    border-radius: 16px;
    margin-top: 22px;
}
</style>